import { APIConfiguration, axiosMYLAB } from 'api';
import { Analysis } from 'models/analysis.model';
import { Paginate } from 'models/utils.model';
import { BaseService } from './base.service';

class AnalysisService extends BaseService {
  async getAnalysis(size: number, page: number, name: string = '', poct?: boolean) {
    const params: { name: string; size: number; page: number; poct?: boolean } = { name, size, page };

    if (poct !== undefined) {
      params.poct = poct;
    }
    const { data } = await axiosMYLAB.get<Paginate<Analysis>>(`${this.apiConfig.ANALYSIS.SEARCH(this.getLang())}`, {
      params,
    });

    this.log('getAnalysis()');

    return data;
  }

  async getAnalysisById(id: string | number) {
    const { data } = await axiosMYLAB.get<Analysis>(this.apiConfig.ANALYSIS.GET_BY_ID(this.getLang(), id));

    this.log('getAnalysisById()');

    return data;
  }
}

export default (apiConfig: APIConfiguration) => {
  return new AnalysisService(apiConfig);
};
